import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Paper, TextField, Button, Typography, Alert, Stack, Box } from '@mui/material';
import { api } from '../services/api';
import { PRIMARY } from '../theme';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const token = params.get('token') || '';

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await api.post('/api/auth/reset-password', { token, newPassword: pwd });
      nav('/login');
    } catch (e) { setErr(e?.response?.data?.message || 'Invalid or expired token'); }
    finally { setBusy(false); }
  };
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: PRIMARY }}>
      <Container maxWidth="xs">
        <Paper sx={{ p: 4 }}>
          <Typography variant="h6" gutterBottom>Choose a new password</Typography>
          <form onSubmit={submit}>
            <Stack spacing={2}>
              {err && <Alert severity="error">{err}</Alert>}
              <TextField label="New password" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} required inputProps={{ minLength: 8 }} />
              <Button type="submit" variant="contained" disabled={busy || !token}>Reset password</Button>
            </Stack>
          </form>
        </Paper>
      </Container>
    </Box>
  );
}
